import { alpha } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  container: {
    borderRadius: '4px',
    overflow: 'hidden',
    position: 'relative',
  },
  overlay: {
    position: 'absolute',
    left: 0,
    top: 0,
    zIndex: '2',
    width: '100%',
    height: '100%',
    pointerEvents: 'none',
    background: 'rgba(0, 133, 255, 0.3)',
  },
  play: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    zIndex: 4,
    cursor: 'pointer',
    transition: 'transform 0.4s ease',
    left: theme.spacing(4),
    top: theme.spacing(4),
  },
  playCompact: {
    left: theme.spacing(2),
    top: theme.spacing(2),
  },
  playCentered: {
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    filter: `drop-shadow(0 0 20px ${theme.palette.grey[300]})`,
  },
  title: {
    color: '#FFF',
    height: '100%',
    textAlign: 'left',
    padding: theme.spacing(0, 2),
    overflow: 'hidden',
    maxWidth: 800, // <- TODO: make this dynamic
    textShadow:
      `1px 1px 0 rgba(0, 0, 0, 0.1),
      -1px 1px 0 rgba(0, 0, 0, 0.1),
      1px -1px 0 rgba(0, 0, 0, 0.1),
      -1px -1px 0 rgba(0, 0, 0, 0.1),
      0px 1px 0 rgba(0, 0, 0, 0.1),
      0px -1px 0 rgba(0, 0, 0, 0.1),
      -1px 0px 0 rgba(0, 0, 0, 0.1),
      1px 0px 0 rgba(0, 0, 0, 0.1),
      2px 2px 0 rgba(0, 0, 0, 0.1),
      -2px 2px 0 rgba(0, 0, 0, 0.1),
      2px -2px 0 rgba(0, 0, 0, 0.1),
      -2px -2px 0 rgba(0, 0, 0, 0.1),
      0px 2px 0 rgba(0, 0, 0, 0.1),
      0px -2px 0 rgba(0, 0, 0, 0.1),
      -2px 0px 0 rgba(0, 0, 0, 0.1),
      2px 0px 0 rgba(0, 0, 0, 0.1),
      1px 2px 0 rgba(0, 0, 0, 0.1),
      -1px 2px 0 rgba(0, 0, 0, 0.1),
      1px -2px 0 rgba(0, 0, 0, 0.1),
      -1px -2px 0 rgba(0, 0, 0, 0.1),
      2px 1px 0 rgba(0, 0, 0, 0.1),
      -2px 1px 0 rgba(0, 0, 0, 0.1),
      2px -1px 0 rgba(0, 0, 0, 0.1),
      -2px -1px 0 rgba(0, 0, 0, 0.1)`,
    [theme.breakpoints.down('md')]: {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      boxSizing: 'border-box',
    },
  },
  titleCompact: {
    padding: theme.spacing(0, 1),
    maxWidth: 280, // <- TODO: make this dynamic
    color: alpha('#FFF', 0.935),
  },
  video: {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    display: 'block',
    margin: 0,
    backgroundColor: theme.palette.text.dark,
  },
  poster: {
    maxWidth: '100%',
    margin: 'auto !important',
    maxHeight: 'inherit',
    display: 'block',
    backgroundColor: theme.palette.text.dark,
    cursor: 'pointer',
    objectFit: 'contain',
    transition: 'filter 0.3s ease',
    '&:not(:hover)': {
      filter: 'grayscale(50%)',
    },
  },
  disableOverlay: {
    filter: 'none !important',
  },
  unplayable: {
    position: 'absolute',
    left: 0,
    top: 0,
    zIndex: '3',
    width: '100%',
    height: '100%',
    padding: theme.spacing(6),
    boxSizing: 'border-box',
    backgroundColor: theme.palette.text.dark,
    color: '#FFF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
}))
